module.exports = __webpack_public_path__ + "static/media/soc.2d273c75.jpg";